import React from 'react';
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Download, AlertTriangle } from "lucide-react";

interface EgameDownloadsTabProps {
    gameId: number;
    link_hun?: string;
}

const EgameDownloadsTab: React.FC<EgameDownloadsTabProps> = ({ gameId, link_hun }) => {
    const handleTrackedClick = async (e: React.MouseEvent<HTMLAnchorElement>) => {
        e.preventDefault();
        const url = e.currentTarget.href;
        const csrfToken = document.querySelector<HTMLMetaElement>('meta[name="csrf-token"]')?.content;

        try {
            await fetch(`/api/statistics/egame_click/${gameId}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-Token': csrfToken || '',
                },
            });
        } catch (error) {
            console.error("Kattintás követése sikertelen:", error);
        } finally {
            window.open(url, '_blank', 'noopener,noreferrer');
        }
    };
    return (
        <Card className="bg-card text-card-foreground border-border">
            <CardContent className="p-6 flex flex-col items-center justify-center">
                {link_hun ? (
                    <Button asChild className="bg-green-600 text-white hover:bg-green-700 text-lg px-8 py-4" >
                        <a href={link_hun} onClick={handleTrackedClick}>
                            <Download className="mr-2 h-5 w-5" /> Ugrás a letöltési oldalra
                        </a>
                    </Button>
                ) : (
                    <div className="flex items-center text-muted-foreground"><AlertTriangle className="mr-2 h-5 w-5 text-yellow-500" />Nincs megadva letöltési link.</div>
                )}
            </CardContent>
        </Card>
    );
};

export default EgameDownloadsTab;